
import HivCarePatientApp from "../../views/patients/pages/patientApp";

const NotAuthenticatedPatient = () => {
    return <HivCarePatientApp />;
}

export default NotAuthenticatedPatient;
